// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__FcgAK","comment":"styles_comment__3xV5v"};